import { Flex, Spinner as SpinnerChakra } from '@chakra-ui/react'

export const Spinner = ({ color = 'blue.500', ...props }) => {
  return (
    <Flex height="150px" align="center" justify="center" {...props}>
      <SpinnerChakra color={color} />
    </Flex>
  )
}
